import { createSlice } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';

import { initialState } from '@webapp/account/src/resources/links/links';
import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { initialLink } from '@webapp/common/entities/link';
import { updateItemInArray } from '@webapp/common/lib/utils';

import { addLink, deleteLink, getLinkParamsList, updateLink } from './async';

export const linksSlice = createSlice({
    name: 'links',
    initialState,
    reducers: {
        editMode({ items }, { payload: { id, mode } }) {
            updateItemInArray(items, id, (i) => {
                i.editing = mode;
            });
        },
    },
    extraReducers: (builder) =>
        addStateFetch(
            builder
                .addCase(getLinkParamsList.fulfilled, (s, { payload: items }) => {
                    s.items = items;
                })
                .addCase(addLink.fulfilled, (s, { payload: { item } }) => {
                    s.items.push(Object.assign(cloneDeep(initialLink), item));
                })
                .addCase(deleteLink.fulfilled, (s, { payload: { id } }) => {
                    s.items = s.items.filter((i) => i.id !== id);
                })
                .addCase(updateLink.fulfilled, ({ items }, { payload: item }) => {
                    updateItemInArray(items, item.id, (i) => {
                        Object.assign(i, item);
                    });
                }),
        ),
});
